// store/balance/useBalanceStore.ts

import { create } from 'zustand';
import { persist, combine } from 'zustand/middleware';
import { questionnaireInitialState, QuestionnaireState } from './questionnaireInitialState';
import { createQuestionnaireSlice, QuestionnaireActions } from './createQuestionnaireSlice';

/**
 * @french
 * Hook Zustand persistant pour la gestion de la questionnaire.
 */
export const useQuestionnaireStore = create<QuestionnaireState & QuestionnaireActions>()(
  persist(combine(questionnaireInitialState, createQuestionnaireSlice as any), {
    name: 'questionnaire-store',
  }),
);
